var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-dialog",
    {
      attrs: { visible: _vm.visible, width: "400px", top: "8vh" },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("ib-dialog-confirmation-content", {
        staticClass: "confirmation-content",
        attrs: {
          image: require("@/assets/img/illustrations/dialogs/upgrade-rocket.svg"),
          title: _vm.$t("dialogs.freeTrialExpired.title"),
          subtitle: _vm.$t("dialogs.freeTrialExpired.subtitle"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }